<template>
    <v-page-data-table
            title="用户管理"
            key-name="id"
            :fields="fields"
            ref="producer"
            @create="onDetail"
            :height="535"
            :show-edit="false"
            :row-actions="rowActions"
            :toolbar-actions="toolActions"
            delete-api="USER_DELETE"
            query-api="USER_QUERY">

        <template v-slot:displayName="{item}">
            <v-link-text :text="item.displayName" @click="onDetail(item)"></v-link-text>
        </template>

        <template v-slot:state="{item}">
            {{item.state==0?'禁用':'启用'}}
        </template>
        <template v-slot:sex="{item}">
            {{item.sex=='M'?'男':'女'}}
        </template>
    </v-page-data-table>
</template>

<script>
    import FndUserQueryFields from "./fields/FndUserQuery";
    import _ from 'lodash';

    export default {
        name: "ProducerQuery",
        data() {
            return {
                fields: FndUserQueryFields,
                rowActions: [],
                toolActions: [
                    {
                        text: '新建用户',
                        color: 'primary',
                        icon: "mdi-account",
                        action: 'create'
                    }
                ]
            }
        },
        methods: {
            onDetail(item) {
                let id = item ? item.id : undefined;
                this.$router.apmRoute("userDetail", {id: id});
            }
        }
    }
</script>
